import Cookies from 'js-cookie';
import { parseCookie } from 'cookie';
import {
  TOKEN_KEY,
} from './constants';
import { $fetch } from './base-fetch';

const AUTH_CODE = [100005, 400200];

export function setToken(token: string) {
  Cookies.set(TOKEN_KEY, token, {
    expires: 30,
    path: '/',
    sameSite: 'Lax',
  });
}

export const clearToken = () => {
  Cookies.remove(TOKEN_KEY, {
    path: '/',
    sameSite: 'Lax',
  });
};

export const getToken = (cookieStr?: string) => {
  const source = cookieStr ?? (typeof document === 'undefined' ? '' : document.cookie);
  const cookieObject = parseCookie(source);

  return cookieObject[TOKEN_KEY] || '';
};

export const isLogin = (cookieStr?: string) => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    const source = cookieStr ?? (typeof document === 'undefined' ? '' : document.cookie);
    const cookieObject = parseCookie(source);

    return Boolean(cookieObject[TOKEN_KEY]);
  }
};

// OAuth 回调地址：站点 /callback，并携带登录前来源路径 from
export const buildRedirectUri = (from: string) => {
  const base = `${window.location.protocol}//${window.location.host}`;

  return `${base}/callback?from=${encodeURIComponent(from)}`;
};

export const gotoLogin = async (from?: string) => {
  const source = from ?? `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const redirectUri = buildRedirectUri(source);

  // 调后端拿 OAuth 跳转地址，再跳转
  const { isSuccess, data } = await $fetch<{ auth_url: string; state: string }>('/api/auth/login', {
    method: 'post',
    data: { redirect_uri: redirectUri },
  });

  if (isSuccess && data?.auth_url) {
    window.location.replace(data.auth_url);
  }
};

export const isAuthCode = (code: number) => AUTH_CODE.includes(code);

export const isValidRedirect = (url: string): boolean => {
  return url.startsWith('/') && !url.startsWith('//');
};
